import { create } from "zustand";
import { CommonResponseModel, knowledgeBaseFiles } from "../models/axiosModel";
import agent from "../services/api";

interface knowledgeBaseStoreInterface { 
    flagUploadKnowledgeBaseFilePopup: boolean, 
    setFlagUploadKnowledgeBaseFilePopup: (value: boolean) => void,
    
    knowledgeBaseFiles: knowledgeBaseFiles[] | null, 
    setKnowledgeBaseFiles: (value: knowledgeBaseFiles[]) => void, 
    getKnowledgeBaseFilesApi: () => Promise<CommonResponseModel<knowledgeBaseFiles | null>>,
}

export const useKnowledgeBaseStore = create<knowledgeBaseStoreInterface>((set) => ({ 
    flagUploadKnowledgeBaseFilePopup: false,
    setFlagUploadKnowledgeBaseFilePopup: (value: boolean) => set({ flagUploadKnowledgeBaseFilePopup: value }),   

    knowledgeBaseFiles: null, 
    setKnowledgeBaseFiles: (value) => set({ knowledgeBaseFiles: value }),  

    getKnowledgeBaseFilesApi: async () => {
        const res = await agent.getKnowledgeBaseFiles.get();
        if (res.status) {
            set({ knowledgeBaseFiles: res?.data })
        }
        else {
            set({ knowledgeBaseFiles: null })
        }
        return res;
    }
}))